import { Response } from "@/models/shared/Response";
import { SkipAssociationResponse } from "@/models/shared/SkipAssociationResponse";

export interface ISkipAssociationService {
  skip(
    url: string
  ): Promise<Response<SkipAssociationResponse>>;
}

export class SkipAssociationService implements ISkipAssociationService {
  async skip(
    url: string
  ): Promise<Response<SkipAssociationResponse>> {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        skipAssociation: true,
      }),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const skipAssociationService = new SkipAssociationService();
